import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormulaireMotDePasse from "@/components/FormulaireMdp/FormulaireMdpComponent";
import { AuthentificationType } from "@/types/AuthentificationType";
import { ChangementMotDePasseProps } from "@/types/ChangementMdpType";
import styles from "./ChangementMotDePasse.module.css";
import { CheckCircle } from "lucide-react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import SocialLogin from "../SocialLogin/SocialLoginComponent";
import { useAuth } from "@/composables/auth";
import { useToast } from "@/composables/toast";

const ChangementMotDePasseComponent: React.FC<ChangementMotDePasseProps> = ({
  mode,
  titre,
  sousTitre,
  description,
  image,
}) => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [error, setError] = useState<string | null>(null);
  const { changePassword, loading } = useAuth();

  const handleSubmit = async (password: string, confirmPassword: string) => {
    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      return;
    }

    try {
      if (!token || typeof token !== "string") {
        throw new Error("Token invalide");
      }

      const params: AuthentificationType = {
        login: token.replace("/changer/mot-de-passe/", ""),
        password: password,
      };

      const success = await changePassword(params);
      if (success) {
        useToast("Mot de passe changé avec succès", {
          variant: "success",
        });
        navigate("/connexion");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Une erreur est survenue");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftColumn}>
        <div className=" mt-8 pl-4">
          <Link
            to="/connexion"
            style={{
              fontSize: "0.875rem",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.25rem",
            }}
          >
            <ArrowLeft size={14} />
            connexion
          </Link>
        </div>
        <h1 className={styles.title}>{titre}</h1>
        <div className={styles.subtitleContainer}>
          <CheckCircle className={styles.icon} />
          <p className={styles.description}>{sousTitre}</p>
        </div>
        <ul className={styles.advantages}>
          {description.map((item, index) => (
            <li key={index} className={styles.advantageItem}>
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <FormulaireMotDePasse
          onSubmit={handleSubmit}
          error={error}
          loading={loading}
        />
        <div style={{ marginTop: "1rem" }}>
          <SocialLogin />
        </div>
      </div>

      <div className={styles.rightColumn}>
        <img
          src={image}
          alt="Conseils mot de passe"
          className={styles.mainImage}
        />
      </div>
    </div>
  );
};

export default ChangementMotDePasseComponent;
